import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { toast } from "react-hot-toast";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";

type props = {
  idDespesaGroupPay: string;
  condominioId?: number | null;
  deveBuscar: boolean;
};

export const useGetDespesaGroupPayDetalhada = (props: props) => {
  const onError = () => {
    toast.error("Erro ao buscar despesa do Group Pay");
  };

  return useQuery<Cond21CloudResponse<DespesaGroupPayDetalhada>>({
    queryKey: ["despesa-group-pay-detalhada", props.idDespesaGroupPay],
    queryFn: async () => {
      const response = await http.get<Cond21CloudResponse<DespesaGroupPayDetalhada>>(
        api.groupPay.getBuscarDespesaDetalhada,
        {
          idDespesaGroupPay: props.idDespesaGroupPay,
          condominioId: props.condominioId || null
        }
      );
      return response.data;
    },
    enabled: props.deveBuscar,
    onError,
  });
};
